import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp } from "./Reveal";

const faqs = [
  {
    q: "What exactly is wash, dry & fold?",
    a: "Simply drop off your laundry (or have it picked up) and we take it from there. Every load is washed with care, dried just right, and folded into crisp, ready-to-put-away bundles — sorted and packed with love.",
  },
  {
    q: "How does pickup & delivery work?",
    a: "Schedule a pickup online in seconds. Our own Spintastic van — backed by trusted gig drivers — collects your laundry from your doorstep and brings it back fresh, clean, and folded. You'll be able to track it every step of the way.",
  },
  {
    q: "Do I need the app to place an order?",
    a: "Not at all. You can order right here on the website — our checkout is powered by Cents & Laundroworks. The Spintastic app for iOS and Android is coming soon and will make scheduling, tracking, and paying even easier.",
  },
  {
    q: "Where do you deliver?",
    a: "We serve Bryans Road and the surrounding Charles County communities from our home at 6980 Indian Head Highway. Not sure if we reach you? Send us a message and we'll confirm right away.",
  },
  {
    q: "Can I just walk in and do my own laundry?",
    a: "Absolutely — that's what we're here for. Our self-service floor has modern, high-capacity washers and dryers in a bright, spotless space. Bring the whole week's worth and make yourself at home.",
  },
  {
    q: "How do I pay?",
    a: "Online orders are paid securely through our Cents-powered checkout. For self-service visits, our machines are coin-friendly and easy to use — just bring your laundry and your quarters.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="mx-auto max-w-7xl scroll-mt-28 px-6 py-32 lg:px-10 lg:py-40"
    >
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5">
          <FadeUp className="lg:sticky lg:top-32">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C85C40]">
              Good to know
            </p>
            <h2 className="mt-4 font-serif text-4xl leading-none tracking-tight sm:text-5xl lg:text-6xl">
              Questions?{" "}
              <span className="italic text-[#C85C40]">We've got answers</span>.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#5C5C5A] md:text-lg">
              Everything you might want to know about washing with us. Still
              curious? We're one message away.
            </p>
          </FadeUp>
        </div>

        <div className="lg:col-span-7">
          <FadeUp delay={0.15}>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-[#E2DFD8]"
                  data-testid={`faq-item-${i + 1}`}
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i + 1}`}
                    className="py-6 text-left font-serif text-xl tracking-tight text-[#1A1A1A] transition-colors duration-300 hover:text-[#C85C40] hover:no-underline sm:text-2xl"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-[#5C5C5A]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
